export default class RoutePlanner {
  constructor(mapMarkers, mapGeometry) {
    this.mapMarkers = mapMarkers;
    this.mapGeometry = mapGeometry;
    this.waypoints = [];
    this.routeType = "tourist";
  }

  addFromWaypoint(coords) {
    this.waypoints.unshift(
      new Waypoint(coords, this.waypoints.length, Waypoint.ADDED_AS_ORIGIN)
    );
    this.redrawWaypoints();
    this.redrawRoute();
  }

  addToWaypoint(coords) {
    this.waypoints.push(
      new Waypoint(coords, this.waypoints.length, Waypoint.ADDED_AS_DESTINATION)
    );
    this.redrawWaypoints();
    this.redrawRoute();
  }

  removeWaypoint(waypointIndex) {
    this.waypoints = this.waypoints.filter(
      (waypoint, index) => index !== waypointIndex
    );

    this.redrawWaypoints();
    this.redrawRoute();
  }

  clearAll() {
    this.waypoints = [];
    this.redrawWaypoints();
    this.redrawRoute();

    $("#route-details").addClass("d-none");
  }

  redrawWaypoints() {
    this.mapMarkers.clearLayers();
    this.mapGeometry.clearLayers();
    const map = this.mapGeometry._map;

    this.waypoints.forEach((waypoint, index) => {
      const coords = waypoint.coords;

      const contextMenuItems = [
        ...map.buildMenuOptions(coords),
        ...[SVGMarker.createRemoveWaypointContextMenuItem(index)],
      ];

      switch (index) {
        case 0:
          if (this.waypoints.length == 1) {
            waypoint.marker =
              waypoint.addedAs === Waypoint.ADDED_AS_DESTINATION
                ? SVGMarker.buildDestinationMarker(
                    coords,
                    index,
                    contextMenuItems
                  )
                : SVGMarker.buildOriginMarker(coords, index, contextMenuItems);
          } else {
            waypoint.marker = SVGMarker.buildOriginMarker(
              coords,
              index,
              contextMenuItems
            );
          }
          break;
        case this.waypoints.length - 1:
          waypoint.marker = SVGMarker.buildDestinationMarker(
            coords,
            index,
            contextMenuItems
          );
          break;
        default:
          waypoint.marker = SVGMarker.buildWayPointMarker(
            coords,
            index,
            contextMenuItems
          );
      }

      waypoint.marker.waypointIndex = index;
      waypoint.marker.on("dragend", (e) => {
        waypoint.setLatLon(e.target.getLatLng());
        this.redrawRoute();
      });
      this.mapMarkers.addLayer(waypoint.marker);
    });
  }

  redrawRoute() {
    this.mapGeometry.clearLayers();
    if (this.waypoints.length < 2) return;
    $("#route-details").removeClass("d-none");

    const sections = [];

    this.fetchRoute(this.waypoints)
      .then((results) => Promise.all(results.map((r) => r.json())))
      .then((sections) => {
        sections.forEach((sectionJson) => {
          this.mapGeometry.addLayer(
            L.geoJson(sectionJson.geometry.geometry, {
              style: () => ({ color: "#5855d9", weight: 5 }),
            })
          );
        });

        this.fetchAltitudes(this.waypoints).then(() =>
          this.renderRouteSummmary(sections)
        );
      });
  }

  fetchRoute(waypoints) {
    const promisesArray = [];

    for (var i = 0; i < waypoints.length - 1; i++) {
      let url = new URL(`https://api.mapy.cz/v1/routing/route`);
      url.searchParams.set("apikey", MAPY_CZ_API_KEY);
      url.searchParams.set("lang", I18n.locale);
      url.searchParams.set("format", "geojson");
      url.searchParams.set(
        "start",
        `${waypoints[i].coords.lng},${waypoints[i].coords.lat}`
      );
      url.searchParams.set(
        "end",
        `${waypoints[i + 1].coords.lng},${waypoints[i + 1].coords.lat}`
      );
      // other possible routeType values include: car_fast, car_fast_traffic, car_short, foot_fast, bike_road, bike_mountain
      url.searchParams.set("routeType", this.routeTypeForMapyCz());

      promisesArray.push(
        fetch(url.toString(), {
          mode: "cors",
        })
      );
    }

    return Promise.all(promisesArray);
  }

  fetchAltitudes(waypoints) {
    let url = new URL(`https://api.mapy.cz/v1/elevation`);
    url.searchParams.set("apikey", MAPY_CZ_API_KEY);
    url.searchParams.set("lang", I18n.locale);

    waypoints.forEach((waypoint) => {
      url.searchParams.append(
        "positions",
        `${waypoint.coords.lng},${waypoint.coords.lat}`
      );
    });

    return fetch(url.toString(), {
      mode: "cors",
    })
      .then((response) => response.json())
      .then((elevationJson) => {
        const elevations = elevationJson.items;
        waypoints.forEach((waypoint, index) => {
          waypoint.altitude = elevations[index].elevation;
        });
      });
  }

  routeTypeForMapyCz() {
    let result;

    switch (this.routeType) {
      case "tourist":
        result = "foot_fast";
        break;
      case "bike":
        result = "bike_road";
        break;
    }

    return result;
  }

  routeTypeIcon() {
    let result;

    switch (this.routeType) {
      case "tourist":
        result = "fa-walking";
        break;
      case "bike":
        result = "fa-biking";
        break;
    }

    return result;
  }

  renderRouteSummmary(sections) {
    $("#route-sections").empty();

    const summary = sections.reduce(
      (acc, value) => {
        acc.totalLength += value.length;
        acc.totalTime += value.duration;

        return acc;
      },
      { totalLength: 0, totalTime: 0 }
    );

    $("#route-total-distance").html(
      `<i class="fa fas ${this.routeTypeIcon()}"></i> ${this.distanceToKm(
        summary.totalLength
      )} km`
    );
    $("#route-total-duration").html(
      `<i class="fa fas fa-watch"></i> ${this.timeToString(summary.totalTime)}`
    );

    sections.forEach((sectionResult, index) => {
      $("#route-sections").append(
        this.renderRouteSection(sectionResult, index, sections.length)
      );
    });

    const isMobile = window.matchMedia(
      "only screen and (max-width: 576px)"
    ).matches;

    this.mapGeometry._map.invalidateSize();
    this.mapGeometry._map.fitBounds(this.mapGeometry.getBounds(), {
      padding: [5, 5],
    });

    if (!isMobile) {
      const coords = this.waypoints[this.waypoints.length - 1].coords;
      L.popup(coords, {
        content: `<div class="p-0">
            <b class="mb-1">${this.timeToString(summary.totalTime)}</b><br />
            ${this.distanceToKm(summary.totalLength)} km
          </div>`,
        offset: [0, -55],
      }).openOn(this.mapGeometry);
    }
  }

  renderRouteSection(sectionResult, index, totalLength) {
    const fromLabel =
      index === 0
        ? I18n.t("js.map.markers.origin_title")
        : (index + 1).toString();
    const toLabel =
      index === totalLength - 1
        ? I18n.t("js.map.markers.destination_title")
        : (index + 2).toString();
    const fromLabelIsNumber = fromLabel.length < 3;
    const toLabelIsNumber = toLabel.length < 3;

    return `
        <div class="route-section my-3 pr-3">
          <div class="markers-and-arrow d-flex flex-row align-items-center">
            ${SVGMarker.markerWithLabel({
              size: 50,
              label: fromLabel,
              verticalPosition: fromLabelIsNumber ? 48 : 44,
              fontSize: fromLabelIsNumber ? 250 : 145,
              color: "#ff3e1a",
            })}

            <div class="flex-grow-1 arrow-container">
              <div class="d-flex justify-content-center">
                <span class="mr-3">${this.distanceToKm(
                  sectionResult.length
                )} km</span> <span>${this.timeToString(
      sectionResult.duration
    )}</span>
              </div>
              <div class="line"></div>
              <div class="point"></div>
            </div>

            ${SVGMarker.markerWithLabel({
              size: 50,
              label: toLabel,
              verticalPosition: toLabelIsNumber ? 48 : 44,
              fontSize: toLabelIsNumber ? 250 : 145,
              color: "#ff3e1a",
            })}
          </div>

          <div class="altitudes mt-2 d-flex justify-content-between">
            ${
              this.waypoints[index].altitude &&
              `
              <span>
              <i class="fas fa-mountains ml-2"></i> ${
                this.waypoints[index].altitude
              } ${I18n.t("js.global.asl")}
              </span>
              <span>
                <i class="fas fa-mountains ml-2"></i> ${
                  this.waypoints[index + 1].altitude
                } ${I18n.t("js.global.asl")}
              </span>
            `
            }
          </div>
          
        </div>
      `;
  }

  toggleSectionDetails(link) {
    if ($("#route-section-details").hasClass("d-none")) {
      $("#route-section-details").removeClass("d-none");
      $(link).html(I18n.t("js.map.route_summary.hide_route_sections"));
    } else {
      $("#route-section-details").addClass("d-none");
      $(link).html(I18n.t("js.map.route_summary.show_route_sections"));
    }
  }

  switchToWalking() {
    this.routeType = "tourist";
    $("#route-type-switch button").removeClass("active");

    $("#switch-to-walking").addClass("active");
    this.redrawRoute();
  }

  switchToBiking() {
    this.routeType = "bike";
    $("#route-type-switch button").removeClass("active");

    $("#switch-to-biking").addClass("active");
    this.redrawRoute();
  }

  distanceToKm(distance) {
    return Math.round(distance / 100) / 10;
  }

  timeToString(time) {
    const durationHours = Math.floor(time / 60 / 60);
    const durationMinutes = Math.round(time / 60) - durationHours * 60;
    const durationHoursString =
      durationHours > 0
        ? `${durationHours} ${I18n.t("js.map.route_summary.hours")}`
        : "";
    const durationMinutesString =
      durationMinutes > 0
        ? `${durationMinutes} ${I18n.t("js.map.route_summary.minutes")}`
        : "";

    return `${durationHoursString} ${durationMinutesString}`.trim();
  }
}

class Waypoint {
  constructor(coords, index, addedAs) {
    this.coords = coords;
    this.addedAs = addedAs;
  }

  setLatLon(latLon) {
    this.coords = latLon;
  }

  static get ADDED_AS_ORIGIN() {
    return 1;
  }
  static get ADDED_AS_DESTINATION() {
    return 2;
  }
}
